export default "#### Yes\n\nComplete your reservation and we’ll reach out with an offer.\n";